/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _BioExamResultsNewEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ApplicationInstance from "@ember/application/instance";
import { action } from "@ember/object";
import { getOwner } from "@ember/owner";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import CrudJournalEventBaseComponent from "core/components/forc/abstract/crud-journal-event-based-component";
import { ToastMessage } from "core/components/forc/abstract/journal-event-based-component";
import DraftManager from "core/components/forc/draft-manager";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import FileAttachment from "core/models/file-attachment";
import Patient from "core/models/patient";
import AnalyticsService from "core/services/analytics";
import NavigationService from "core/services/navigation";
import { BufferedChangeset } from "ember-changeset/types";
import ApplicationAdapter from "parog-web/adapters/application";
let BioExamResultsNewEditionFormComponent = (_class = (_BioExamResultsNewEditionFormComponent = class BioExamResultsNewEditionFormComponent extends CrudJournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "analytics", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "navigation", _descriptor3, this);
    _defineProperty(this, "applicationAdapter", getOwner(this).lookup("adapter:application"));
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
  }
  get changeset() {
    this.draft = new DraftManager(this);
    return this.args.changeset;
  }
  get toastMessage() {
    return {
      message: "Vos résultats biologiques ont bien été pris en compte.",
      title: "Biologie"
    };
  }
  async save() {
    this.changeset.set("normalized", true);
    // Need to persist this.isNewMode because even if it a new model, after `super.save()` this.isNewMode turn to false
    const isNewMode = this.isNewMode;
    const model = await super.save();
    if (isNewMode) {
      await this.store.createRecord("patient-chat-message-sent-journal-event", {
        occurredAt: new Date(),
        triggeringJournalEvent: model,
        patient: model.patient,
        creator: model.creator,
        body: "Résultats d'examen envoyés"
      }).save();
      await fetch(`/api/v1/task_planned_journal_event/${model.patient.id}/create_bio_task`, {
        method: "POST",
        headers: Object.assign({
          "Content-Type": "application/json"
        }, this.applicationAdapter.headers)
      });
    }
    if (this.args.afterCompleted) this.args.afterCompleted();
    return model;
  }

  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when upload is successful.
   */
  onSelected(file) {
    const files = this.changeset.get("files");
    const isFirstSelectedFile = Boolean(!files);
    if (isFirstSelectedFile) {
      this.changeset.set("files", [file]);
    } else {
      files.push(file);
      this.changeset.set("files", files);
    }
  }

  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when a file is deleted.
   */
  destroyFile(index) {
    const files = this.changeset.get("files");
    files?.splice(index, 1);
    this.changeset.set("files", files);
  }

  /**
   * File upload accepted types.
   * When upload button is clicked and
   * file explorer opens, only those
   * types would be uploadable.
   */
  get acceptedTypes() {
    return ["application/pdf", "image/jpeg", "image/jpg", "image/png", "application/rtf"];
  }
  back() {
    this.navigation.back();
  }
  get fileAttachments() {
    return this.changeset.orderedFileAttachments || [];
  }
}, _defineProperty(_BioExamResultsNewEditionFormComponent, "forcDisplayName", "Résultats biologiques"), _defineProperty(_BioExamResultsNewEditionFormComponent, "fullComponentId", "bio-exam-results/new-edition-form"), _defineProperty(_BioExamResultsNewEditionFormComponent, "journalEventClass", BioExamResultsReceivedJournalEvent), _BioExamResultsNewEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "analytics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "navigation", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyFile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyFile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "back", [action], Object.getOwnPropertyDescriptor(_class.prototype, "back"), _class.prototype), _class);
export { BioExamResultsNewEditionFormComponent as default };